import { batch } from 'react-redux';

import { setBonusesAmount, setQrCode, setQrLink } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import validateBonusesAmount from './validateBonusesAmount';

const updateBonusesAmount = (amount: number) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const { seasonTicketPayment: { sbpInfo: { qrLink, qrCode } } } = getState();

        if (qrLink) {
            dispatch(setQrLink(''));
        }
        if (qrCode) {
            dispatch(setQrCode(''));
        }

        batch(() => {
            dispatch(setBonusesAmount(amount));
            dispatch(validateBonusesAmount());
        });
    };
};

export default updateBonusesAmount;
